export default function Impressum() {
    return (
        <div className="space-y-6">
            <h2 className="text-3xl font-serif">Impressum</h2>

            <p className="text-sm text-gray-600 leading-relaxed">
                Angaben gemäß § 5 TMG
            </p>

            <p className="text-sm text-gray-600 leading-relaxed">
                AK ORIGINS<br />
                Tegernseer Landstraße 256<br />
                81549 München<br />
                Deutschland
            </p>

            <p className="text-sm text-gray-600 leading-relaxed">
                E-Mail: mail@ak-origins.de
            </p>
        </div>
    );
}
